import go from "./go";
import back from "./back";
import reLaunch from "./reLaunch";
import replace from "./replace";
import push from "./push";
import switchTab from "./switchTab";
export { go, push, reLaunch, switchTab, replace, back };
export default {
  push: push,
  back: back,
  reLaunch: reLaunch,
  switchTab: switchTab,
  replace: replace,
  go: go
};